import axiosClient from ".";

class PoolBalanceWithdrawal {
  static pool_balance_withdrawal(data) {
    return axiosClient.post(`/super_admin/api/pool_balance_withdrawal`, data);
  }
}
export default PoolBalanceWithdrawal;
